/**
 * @file: 画布tpl申明
 * @author: xiaolong.huang@dmall.com
 */

let tpl: string = `
    <div class="shelvesbuild-e-sketchpad" data-stagecore>
        <ul class="J_lockSelect">
            <li>任意</li>
            <li>商品</li>
            <li>组件</li>
        </ul>
        <div class="J_shelvesSketchpad slot"></div>
        <div class="shelvesbuild-w-contextmenus" style="display: none" data-stagecore>
            <div class="list J_MenuCont">
                <section class="menu"></section>
            </div>
        </div>
        <div class="shelvesbuild-e-sketchpad__zoom-mask" id="shelvesbuild-e-sketchpad__zoom-mask"></div>
        <div class="shelvesbuild-e-sketchpad__mask" id="shelvesbuild-e-sketchpad__mask"></div>
        <div class="shelvesbuild-e-sketchpad__e-mask" id="shelvesbuild-e-sketchpad__e-mask"></div>
        <div class="shelvesbuild__drag-transfer" id="shelvesbuild__drag-transfer"></div>
        <div class="shelvesbuild__select-rect" id="shelvesbuild__select-rect"></div>
        <div class="shelvesbuild__drag-arrow" id="shelvesbuild__drag-arrow"></div>
        <div class="shelvesbuild__drag-arrow2" id="shelvesbuild__drag-arrow2"></div>
        <div class="shelvesbuild__drag-line" id="shelvesbuild__drag-line"></div>
        <div class="shelvesbuild__drag-line2" id="shelvesbuild__drag-line2"></div>
    </div>
`;

export default tpl;
